<template>
 <div>
  <div class="banner_footer show-pc">
    <div class="banner_footer_content">
      <div v-for="item in footerList" :key="item.key" class="footer_items">
        <div class="left"><img style="width: 56px;height: 56px;" :src="item.iconUrl" /></div>
        <div class="right">
          <div class="title">{{item.title}}</div>
          <div class="tip">{{item.tip}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="banner_footer_h5 show-h5">
    <div class="banner_footer_content_h5">
      <div v-for="item in footerList" :key="item.key" class="footer_items">
        <div class="left"><img class="left_img" :src="item.iconUrl" /></div>
        <div class="right">
          <div class="title">{{item.title}}</div>
          <div class="tip">{{item.tip}}</div>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
const footerList = [
  {
    key: 'footer_1',
    iconUrl: require('@/assets/images/home_icon_04_zh.png'),
    title: 'SAP认证合作伙伴',
    tip: '与全球知名ERP服务商达成合作'
  },
  {
    key: 'footer_2',
    iconUrl: require('@/assets/images/home_icon_05_zh.png'),
    title: '权威投资机构认可',
    tip: '华盟·税纪云平台获千万美元级机构融资'
  },
  {
    key: 'footer_3',
    iconUrl: require('@/assets/images/home_icon_06_zh.png'),
    title: '技术专利业界领先',
    tip: '多项软著及专利｜腾讯SaaS技术联盟成员'
  }
]
export default {
  name: '',
  props: {},
  components: {},
  data () {
    return {
      footerList
    }
  },
  filters: {},
  watch: {

  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style scoped lang='less'>
  .banner_footer {
    width: 100%;
    height: 94PX;
    background-color: #ffffff;
    .banner_footer_content {
      width: 1200PX;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .footer_items {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          margin-right: 8PX;
        }
        .right {
          .title {
            font-size: 16PX;
            color: #292F3A;
            font-weight: 600;
          }
          .tip {
            font-size: 14PX;
            color: #6E788B;
            line-height: 24PX;
            font-weight: 400;
          }
        }
      }
    }
  }
  .banner_footer_h5 {
    width: 100%;
    height: auto;
    padding-bottom: 6rem;
    background-color: #ffffff;
    .banner_footer_content_h5 {
      height: 100%;
      padding-top: 4rem;
      margin: 0 2rem;
      .footer_items {
        height: 9.2rem;
        background: #FFFFFF;
        box-shadow: 0px 2px 16px 0px rgba(226,234,248,1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        .left {
          margin-right: 1.2rem;
          margin-left: 2rem;
        }
        .left_img {
          width: 96px;
          height: 96px;
        }
        .right {
          .title {
            font-size: 1.6rem;
            color: #292F3A;
            line-height: 2.4rem;
            font-weight: 500;
            margin-bottom: .8rem;
          }
          .tip {
            font-size: 1.3rem;
            color: #848D9E;
            line-height: 2rem;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/honour.vue